// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"d0a9aec7","156":"d83c0e23","338":"a6d730dd","457":"87354ae7","484":"c0e7e6b3","551":"1cb374f4","645":"3559a636","828":"3ec11c4d","842":"4f783d39","851":"3aac5450"}[chunkId] + ".chunk.js";
};